import { Mail } from "lucide-react";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";

interface UpgradeDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  limit?: number;
}

/** Shown when the user hits their plan's minute allowance. No Stripe — contact only. */
export function UpgradeDialog({ open, onOpenChange, limit = 300 }: UpgradeDialogProps) {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="sm:max-w-md">
        <DialogHeader>
          <DialogTitle>You've used all {limit} free minutes</DialogTitle>
          <DialogDescription>
            Your free plan includes {limit} minutes of transcription. To keep processing recordings,
            get in touch and we'll help you upgrade.
          </DialogDescription>
        </DialogHeader>
        <DialogFooter className="sm:justify-end gap-2">
          <Button variant="outline" onClick={() => onOpenChange(false)}>
            Not now
          </Button>
          <Button asChild className="gap-2">
            <a href="mailto:ag@eduarta.com?subject=Eduarta%20plan%20upgrade">
              <Mail className="w-4 h-4" />
              Contact us
            </a>
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}

export default UpgradeDialog;
